"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelfDefendingTemplate = SelfDefendingTemplate;
function SelfDefendingTemplate() {
    return `
        const {selfDefendingFunctionName} = {callControllerFunctionName}(this, function () {
            return {selfDefendingFunctionName}
                .toString()
                .search('(((.+)+)+)+$')
                .toString()
                .constructor({selfDefendingFunctionName})
                .search('(((.+)+)+)+$');
        });
        
        {selfDefendingFunctionName}();
    `;
}
